import api from './config';

export const paymentsAPI = {
  // Criar boleto
  createBoleto: async (data) => {
    const response = await api.post('/payments/create-boleto', data);
    return response.data;
  },

  // Criar PIX
  createPix: async (data) => {
    const response = await api.post('/payments/create-pix', data);
    return response.data;
  },

  // Criar pagamento com cartão
  createCardPayment: async (data) => {
    const response = await api.post('/payments/create-card', data);
    return response.data;
  },

  // Buscar cartão salvo
  getSavedCard: async () => {
    const response = await api.get('/payments/saved-card');
    return response.data;
  },

  // Ativar/desativar cobrança automática
  toggleAutoRecurring: async (autoRecurring) => {
    const response = await api.put('/payments/toggle-auto-recurring', { autoRecurring });
    return response.data;
  },

  // Remover cartão salvo
  deleteSavedCard: async () => {
    const response = await api.delete('/payments/saved-card');
    return response.data;
  },

  // Listar meus pagamentos
  getMyPayments: async () => {
    const response = await api.get('/payments/my-payments');
    return response.data;
  },

  // Deletar pagamento do histórico
  deletePayment: async (id) => {
    const response = await api.delete(`/payments/${id}`);
    return response.data;
  },
};

export default paymentsAPI;

